export const queryLockMessage = 'The request should not update, use forceFetch or set smartFetch:false in the environement options';
export const mutationLockMessage = 'The mutation should not be executed, use forceMutate or set smartMutate:false in the environement options';


// WEBPACK FOOTER //
// ./lib/config.js